import { DICTONARY } from 'const/Dictonary';
import { AuthContext } from 'context';
import { useContext } from 'react';
import adminService from 'services/admin';
import { AlertaError } from 'utils/Alertas';

export const useServices = () => {
  const { perfiles } = useContext(AuthContext);
  const { tipoNegocio } = useContext(AuthContext);

  const cargarPerfiles = async (
    setPerfiles,
    setIsLoadingPerfiles,
    params,
    roles
  ) => {
    try {
      setIsLoadingPerfiles(true);
      const { data } = await adminService.getPerfiles(params);
      const { content } = data;
      let isSuperAdmin = perfiles.isSuperAdmin;
      //si no es superadmin se filtran los perfiles por los restringidos por defecto
      if (isSuperAdmin) {
        setPerfiles(
          roles && roles.length > 0
            ? filtroPerfilesPorRoles(content, roles)
            : content
        );
      } else {
        setPerfiles(
          filtroPerfilesRestringidos(filtroPerfilesPorRoles(content, roles))
        );
      }
    } catch (error) {
      console.log(error);
      AlertaError('Error al cargar los perfiles');
    } finally {
      setIsLoadingPerfiles(false);
    }
  };

  const filtroPerfilesNegocio = perfiles => {
    if (!perfiles) {
      throw new Error('No hay perfiles');
    }
    const perfilesNegocio = tipoNegocio;
    const perfilesFiltrados = perfiles.filter(
      perfil =>
        perfilesNegocio.findIndex(name =>
          perfil.nombrePerfil.toLowerCase().includes(name.toLowerCase())
        ) >= 0
    );
    return perfilesFiltrados;
  };

  const filtroPerfilesRestringidos = perfiles => {
    return perfiles.filter(
      perfil =>
        perfil.codigoPerfil !==
          DICTONARY.CODIGOS_PERFILES.SUPER_ADMINISTRADOR &&
        perfil.codigoPerfil !==
          DICTONARY.CODIGOS_PERFILES.ANALISTA_TERRITORIAL &&
        perfil.codigoPerfil !== DICTONARY.CODIGOS_PERFILES.USUARIO
    );
  };

  const filtroPerfilesPorRoles = (perfiles, roles) => {
    if (!perfiles || perfiles.length === 0) {
      return [];
    }

    if (!roles || roles.length === 0) {
      return [];
    }

    const nombresRoles = roles.map(r =>
      typeof r === 'string' ? r.toLowerCase() : r.nombreRol.toLowerCase()
    );
    const perfilesFiltrados = perfiles.filter(perfil =>
      nombresRoles.some(nombreRol =>
        perfil.nombrePerfil.toLowerCase().endsWith(nombreRol)
      )
    );
    return perfilesFiltrados;
  };

  return { cargarPerfiles, filtroPerfilesNegocio };
};
